<div class="container-fluid">
  <div class="invoiceWrapper">
    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-lg-10">
        <div class="card">
          <div class="card-body">
            <div class="headerWrapper">
              <h4> RFID Printing</h4>
              <div class="buttonWrapper">
                <a href="#/home/bulk-upload/6" class="btn btn-success btn-sm" mat-raised-button><i
                  aria-hidden="true" class="fa fa-plus"></i>Import RFID</a>
                <!--<button *ngIf="addPermission === true" (click)="openDialog()" class="btn btn-success btn-sm" mat-raised-button><i
                  aria-hidden="true" class="fa fa-plus"></i>ADD NEW
                </button>
                <button *ngIf="editPermission === true" (click)="openEditDialog(selectedIndex)" class="btn btn-warning btn-sm"><i
                  aria-hidden="true" class="fa fa-pencil-square-o"></i>DETAILS / PRINT
                </button>
                <button *ngIf="deletePermission === true" (click)="deleteDialog(selectedIndex)" class="btn btn-danger btn-sm"><i aria-hidden="true"
                                                         class="fa fa-trash"></i>DELETE
                </button>-->
              </div>
            </div>
            <div class="customModal">
            </div>
            <table class="table table-bordered" *ngIf="viewPermission === true">
              <thead>
              <tr>
                <th class="col1" scope="col">SI.No</th>
                <th class="col3" scope="col">Product Code</th>
                <th class="col6" scope="col">Product Name</th>
                <th class="col2" scope="col">Expire Date</th>
                <th class="col5" scope="col">Batch Number</th>
                <th class="col6" scope="col">Quantity</th>
                <th scope="col">Action</th>
              </tr>
              </thead>
              <tbody>
              <tr (click)="selectRow(i)"
                  *ngFor="let in of invoice | paginate: { id: 'invoicePageId', itemsPerPage: per_page, currentPage: current_page, totalItems: total_count}; let i = index; let isFirst= first" [ngClass]="{'sel': i === selectedIndex }"
                  style="height: 36px;">
                <th scope="row">{{in.id}}</th>
                <td class="col9">{{in.product_code}}</td>
                <td class="col12">{{in.name}}</td>
                <td class="col8">{{in.date | date:'yyyy-MM-dd'}}</td>
                <td class="col11">{{in.batch_no}}</td>
                <td class="col12">{{in.quantity}}</td>
                <td>
                  <div *ngIf="in.is_printed == '0' && editPermission" class="input-group">
                        <span class="input-group-btn cancelIcon">
                            <button class="btn btn-default" type="button">
                                <i (click)="confirmationModal(i, in)" aria-hidden="true"
                                   class="fa fa-print"></i>

                            </button>
                        </span>
                  </div>
                  <div *ngIf="in.is_printed == '1' && editPermission" class="input-group">
                        <span class="input-group-btn cancelIcon">
                            Printed
                        </span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="footerWrapper row">
              <div class="col-lg-7 col-md-12 col-sm-12">

                <div class="input-group">
                  <select (change)="getSearchValue()" [(ngModel)]="searchBy" data-show-content="true" name="searchBy" class="form-control border">
                    <option name="invoiceNo" value="0"> Search by SI No</option>
                    <option name="invoiceDate" value="1"> Search by Date</option>
                    <option name="invoiceNoWare" value="2"> Search by Product Code</option>
                  </select>

                  <input [(ngModel)]="searchTxt" [placeholder]="placeHolder" class="form-control" name="searchTxt" placeholder="Search" type="text">
                  <span (click)="doSearch()" class="input-group-text">
                            <i aria-hidden="true" class="fa fa-search"></i>
                        </span>
                  <span (click)="doRefresh()" class="input-group-text">
                            <i aria-hidden="true" class="fa fa-refresh"></i>
                        </span>
                </div>
              </div>
              <div class="col-lg-5 col-md-12 col-sm-12">
                <app-common-page (pageChange)="doPaginate($event)" [id]="invoicePageId">
                </app-common-page>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-1"></div>

    </div>


  </div>


</div>
